export default "__VITE_ASSET__v8jiqRg1__"